"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaType = void 0;
exports.MediaType = {
    VIDEO: 'video',
    SCREENSHOT: 'screenshot',
    THUMBNAIL: 'thumbnail',
    WIDETHUMBNAIL: 'widethumbnail',
    MAPBACKGROUND: 'mapbackground',
    MAPLOCATION: 'maplocation',
    UNKNOWN: 'unknown',
    TABTHUMBNAIL: 'tabthumbnail',
    TABBACKGROUND: 'tabbackground',
    TABICON: 'tabicon',
    TAG_ICON: 'tag_icon',
    IAPIMAGE: 'iapimage',
    BANNER_MOON_BACKGROUND: 'banner_moon_background',
    BANNER_PORTRAIT_LARGE_BACKGROUND: 'banner_portrait_large_background',
    BANNER_LANDSCAPE_TOP_PANEL_BACKGROUND: 'banner_landscape_top_panel_background',
    BANNER_LANDSCAPE_SPEECH_BUBBLE_BACKGROUND: 'banner_landscape_speech_bubble_background',
    BANNER_LANDSCAPE_WITH_BUTTON_BACKGROUND: 'banner_landscape_with_button_background',
    BANNER_LANDSCAPE_WIDE_BACKGROUND: 'banner_landscape_wide_background',
    BANNER_RECTANGULAR_MEDIUM_BACKGROUND: 'banner_rectangular_medium_background',
    PORTAL: 'portal',
};
